import React from 'react';
import { Table, Button, Popconfirm, Form, InputNumber, Space, Card, Spin, Select, message } from 'antd'
import { debounce } from 'lodash';
import ImportMdoal from './ImportMdoal';
import { PostJson, PostForm } from '../../utils/http';

export function DebounceSelect({ debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      if (!value) return;
      setOptions([]);
      setFetching(true);
      PostForm({
        url: '/api/mock/fuzzySearchSymbol',
        data: { keyword: value },
        error: (data) => {
          const symbolsList = Object.keys(data).splice(0, 20).map(item => ({
            symbol: item,
            cnname: data[item],
            value: item,
            label: `${item} ${data[item]}`,
          }));
          setOptions([...symbolsList]);
          setFetching(false);
        },
      });
    };
    return debounce(loadOptions, debounceTimeout, { leading: true });
  }, [debounceTimeout, setFetching]);
  return (
    <Select
      showSearch
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      onChange={val => {
        const rec = options.find(item => item.value === val.value)
        props.onChange(rec)
      }}
      style={{ width: 200 }}
      options={options}
    />
  );
} // Usage of DebounceSelect

class MockPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      symbol: undefined,
      dataSource: [],
      showImport: false,
      loading: false,
    }
    this.formRef = React.createRef();
  }
  handleSubmit = async () => {
    const { dataSource, symbol } = this.state;
    console.log(symbol);
    const values = await this.formRef.current.validateFields();
    this.setState({
      dataSource: [
        ...dataSource,
        {
          symbol: symbol.symbol,
          name: symbol.cnname,
          last: +values.last || 0,
          preClose: +values.preClose || 0,
          open: +values.open || 0,
          high: +values.high || 0,
          low: +values.low || 0,
        }
      ],
      symbol: undefined
    });
    this.formRef.current.resetFields();
  }
  handleMock = async () => {
    const { dataSource } = this.state;
    this.setState({ loading: true });
    PostJson({
      url: '/api/mock/mockQuotes',
      data: dataSource,
      success: ({ code = 200, msg }) => {
        if (code === 200) message.success(msg || '操作成功');
        else message.error(msg || '操作失败');
      },
      final: () => {
        this.setState({ loading: false });
      }
    });
  }
  render() {
    const { dataSource, symbol, showImport } = this.state;
    return (
      <Card bodyStyle={{ padding: 0 }}>
        <div>
          <Form ref={this.formRef} layout='inline' style={{ marginLeft: '10px' }}>
            <Form.Item style={{ marginTop: '10px' }} label="股票" getValueFromEvent={() => symbol} rules={[{ required: true, message: '请选择股票' }]}>
              <DebounceSelect value={symbol} placeholder="请选择股票" onChange={val => this.setState({ symbol: val })} />
            </Form.Item>
            <Form.Item style={{ marginTop: '10px' }} label="最新价" name="last">
              <InputNumber placeholder="请输入最新价" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item style={{ marginTop: '10px' }} label="昨收价" name="preClose">
              <InputNumber placeholder="请输入昨收价" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item style={{ marginTop: '10px' }} label="开盘价" name="open">
              <InputNumber placeholder="请输入开盘价" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item style={{ marginTop: '10px' }} label="最高价" name="high">
              <InputNumber placeholder="请输入最高价" style={{ width: '100%' }} />
            </Form.Item>
            <Form.Item style={{ marginTop: '10px' }} label="最低价" name="low">
              <InputNumber placeholder="请输入最低价" style={{ width: '100%' }} />
            </Form.Item>
          </Form>
          <Space style={{ margin: '10px' }}>
            <Button type='primary' onClick={this.handleSubmit}>提交</Button>
            <Button type='danger' onClick={() => this.setState({ dataSource: [] })}>一键删除</Button>
            <Button type='primary' onClick={() => this.setState({ showImport: true })}>导入mock数据</Button>
          </Space>
        </div>
        <Table
          dataSource={dataSource}
          size='small'
          columns={[
            {
              title: '股票',
              dataIndex: 'symbol',
            },
            {
              title: '股票中文名',
              dataIndex: 'name',
            },
            {
              title: '最新价',
              dataIndex: 'last',
            },
            {
              title: '昨收价',
              dataIndex: 'preClose',
            },
            {
              title: '开盘价',
              dataIndex: 'open',
            },
            {
              title: '最高价',
              dataIndex: 'high',
            },
            {
              title: '最低价',
              dataIndex: 'low',
            },
            {
              title: '操作',
              dataIndex: 'action',
              render: (text, record, idx) => (
                <Popconfirm
                  title="确认删除吗？"
                  onConfirm={() => dataSource.splice(idx, 1) && this.setState({ dataSource: [...dataSource] })}
                  okText="确认"
                  cancelText="取消"
                >
                  <Button type="link" size='small'>
                    删除
                  </Button>
                </Popconfirm>
              )
            }
          ]}
        />
        <Button loading={this.state.loading} style={{ margin: '10px' }} type='primary' onClick={this.handleMock}>MOCK</Button>
        {
          showImport &&
          <ImportMdoal
            onHide={() => this.setState({ showImport: false })}
            addSymbol={val => this.setState({ dataSource: [...dataSource, ...val] })}
          />
        }
      </Card>
    )
  }
}

export default MockPage;